import React, {forwardRef, useState} from 'react';
// import CommunityImg from '../../Common/CommunityImg/CommunityImg';
import {default as img1} from '../../../images/industry_experts_join_img1.svg';
import {default as img2} from '../../../images/industry_experts_join_img2.svg';
import {default as img3} from '../../../images/industry_experts_join_img3.svg';
import Button from '../../Common/Button/Button';
import IndustryExpertsJoinModal from '../IndustryExpertsJoinModal/IndustryExpertsJoinModal';
// import {default as border} from '../../images/eventBorder.svg';
import './IndustryExpertsJoin.scss';

const IndustryExpertsJoin = forwardRef(({ isAllEvents }, ref) => {

  const openLink = () => window.open(`https://www.noissue.co/partnership-application/`, '_blank', 'noopener');

  const [open, setOpen] = useState(false);

  return (
    <>
      {/* <div className="industry-experts-join-container-border" ref={ref} /> */}
      <div className="industry-experts-join-container" ref={ref}>
        <div className="industry-experts-join-advise">
          <img src={img1} alt="expert advise" />
        </div>

        <div className="industry-experts-join-details">
          <div className="industry-experts-join-title">
            Interested in becoming an Expert?
          </div>
          <div className="industry-experts-join-sub-title">
          Share your expertise and connect with small businesses around the globe! 
          </div>
          <div className="industry-experts-join-button">
            <Button 
              label="Apply to Join"
              onClick={() => setOpen(true)} />
              {/* onClick={openLink} /> */}
          </div>
        </div>

        <div className="industry-experts-join-location web">
          <img src={img2} alt="expert location" />
        </div>
        <div className="industry-experts-join-location mobile">
          <img src={img3} alt="expert location" />
        </div>
      </div>
      {
        open && <IndustryExpertsJoinModal 
            onClose={()=>setOpen(false)} 
            isOpen={open} 
          />
      }
      {/* <div className={`industry-experts-join-container-border bottom ${isAllEvents && 'all-events'}`} /> */}
    </>
  )
})

export default IndustryExpertsJoin;